module.exports = __webpack_public_path__ + "img/step07_b_insert_bottom_cross_into_right_bottom_connector.b0c1211f.png";